import { generateEntityKey } from "@src/presentation/pages/Organizations/utils/addEditFormUtils";

export const PRODUCT_UOM_CODE_ALREADY_EXISTS_MESSAGE =
  "This UOM Code already exists.";

export const PRODUCT_UOM_CODE_MAX_LENGTH = 10;
export const PRODUCT_UOM_NAME_MAX_LENGTH = 100;
export const PRODUCT_UOM_DESCRIPTION_MAX_LENGTH = 255;

const PRODUCT_UOM_CODE_CHARS = /[^A-Z0-9-]/g;
const PRODUCT_UOM_CODE_PATTERN = /^[A-Z0-9]+(-[A-Z0-9]+)*$/;
const PRODUCT_UOM_CODE_FORMAT_MESSAGE =
  "Only uppercase letters, numbers, and hyphens are allowed";

function getMutationErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.trim() : "";
}

export function isProductUomCodeDuplicateError(error: unknown): boolean {
  const normalized = getMutationErrorMessage(error).toLowerCase();
  return normalized.includes("uom code") && normalized.includes("already exists");
}

export function generateProductUomCodeFromName(name: string): string {
  return generateEntityKey(
    name,
    PRODUCT_UOM_CODE_CHARS,
    PRODUCT_UOM_CODE_MAX_LENGTH,
  );
}

export function sanitizeProductUomCodeInput(raw: string): string {
  return raw
    .toUpperCase()
    .replaceAll(/\s+/g, "-")
    .replaceAll(PRODUCT_UOM_CODE_CHARS, "")
    .replaceAll(/-+/g, "-")
    .slice(0, PRODUCT_UOM_CODE_MAX_LENGTH);
}

export function createProductUomCodeRules() {
  return [
    { required: true, message: "UOM code is required" },
    {
      pattern: PRODUCT_UOM_CODE_PATTERN,
      message: PRODUCT_UOM_CODE_FORMAT_MESSAGE,
    },
    {
      max: PRODUCT_UOM_CODE_MAX_LENGTH,
      message: `UOM code must be less than or equal to ${PRODUCT_UOM_CODE_MAX_LENGTH} characters.`,
    },
  ];
}
